export enum UserStatus {
  Approved = 'approved',
  Rejected = 'rejected',
  Locked = 'locked',
  Closed = 'closed',
  EmailConfirmed = 'email_confirmed',
  Onboarding = 'onboarding',
  VerificationBlocked = 'id_verification_blocked',
  ChangesRequired = 'changes_required',
  ApplicationWithdrawn = 'application_withdrawn',
  Reviewable = 'reviewable',
}

export enum ApplicationRejectedReason {
  ApplicantName = 'applicant_name',
  Address = 'address',
  Birthdate = 'birthdate',
  PortfolioLink = 'portfolio_link',
}
